export const alphaNumeric = /^[a-zA-Z0-9-]*$/;
export const alphanumericMajuscule = /^[A-Z0-9-]*$/;
export const integerOnly = /^[0-9]*$/;
export const numberUpToFourDigitsAndTwoDecimals = /^[0-9]\d{0,3}(\.[0-9]{1,2})?$/; // Pour les ects
export const yearAsInteger = /^[0-9]{4}$/;
export const numberWithTwoDigits = /^[0-9]{2}$/;
